import * as React from "react";
import {PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {observer} from "mobx-react";
import {CurrencyUtils} from "PageBuilder/utils/CurrencyUtils";
import {CurrencySettings} from "PageBuilder/utils/CurrencySettings";

@observer
export class CurrencyAndDateSettings extends React.Component<CurrencyAndDateSettingsProps, CurrencyAndDateSettingsState> {
    static defaultProps: Partial<CurrencyAndDateSettingsProps> = {};

    constructor(props: CurrencyAndDateSettingsProps) {
        super(props);
        this.state = {};
    }

    public render() {
        CurrencyUtils.GetInstance().Config=this.props.Options.DocumentSettings.CurrencySettings;
        return (
            <div>
                <RNTextInput<CurrencySettings> Store={this.props.Options.DocumentSettings.CurrencySettings} PropertyName={"Symbol"} Label={'Currency Symbol'}/>
                <SearchableSelect<CurrencySettings> Store={this.props.Options.DocumentSettings.CurrencySettings} PropertyName={"Position"} Label={'Currency Position'} >
                    <option value={'left'} key={'left'}>Left</option>
                    <option value={'right'} key={'right'}>Right</option>
                    <option value={'left_space'} key={'left_space'}>Left with space</option>
                    <option value={'right_space'} key={'right_space'}>Right with space</option>
                </SearchableSelect>
                <RNTextInput<CurrencySettings> Store={this.props.Options.DocumentSettings.CurrencySettings} PropertyName={"ThousandSeparator"} Label={'Thousand Separator'}/>
                <RNTextInput<CurrencySettings> Store={this.props.Options.DocumentSettings.CurrencySettings} PropertyName={"DecimalSeparator"} Label={'Decimal Separator'}/>
                <RNTextInput<CurrencySettings> Store={this.props.Options.DocumentSettings.CurrencySettings} PropertyName={"NumberOfDecimals"} Label={'Number of decimals'} type={'numeric'}/>
                <fieldset style={{border:'1px solid #dfdfdf',padding:5,borderRadius:5}}>
                    <legend style={{width:'auto',padding:0,marginBottom:0,marginLeft:10,fontSize:14,border:"none"}}>Preview</legend>
                    <p style={{margin:0,textAlign:'center',fontSize:18,fontWeight:'bold'}}>{CurrencyUtils.GetInstance().FormatValue(1000.99)}</p>
                </fieldset>
            </div>

        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface CurrencyAndDateSettingsProps {
    Options:PDFDocumentOptions
}

interface CurrencyAndDateSettingsState {

}

//#endregion "My Region"